import { render, staticRenderFns } from "./merchant-item.vue?vue&type=template&id=141e7c44&scoped=true&"
import script from "./merchant-item.vue?vue&type=script&lang=js&"
export * from "./merchant-item.vue?vue&type=script&lang=js&"
import style0 from "./merchant-item.vue?vue&type=style&index=0&id=141e7c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e7c44",
  null
  
)

export default component.exports